module.exports = __webpack_public_path__ + "img/Temperatura.42931356.svg";